<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <div class="card shadow-sm" style="border: 2px solid black;">
                    <div class="card-body p-3">
                        <h3 class="mt-2 text-center oswald">
                            {{ $t('pages.locker.my_aform.tranings_completed', {count: total}) }}
                            <i class="mdi mdi-check-decagram mdi-36px float-right"></i>
                        </h3>
                    </div>
                </div>

            </div>
            <div class="col-md-6">
                <div class="card shadow-sm" style="border: 2px solid black;">
                    <div class="card-body p-3">
                        <h3 class="mt-2 text-center oswald">
                            {{ $t('pages.locker.my_aform.tranings_completed_this_month', {
                                count: current_month,
                                dateStart: $date(dateFrom).format("DD.MM.YYYY"),
                                dateEnd: $date(dateTo).format("DD.MM.YYYY"),
                            } )}}
                            <i class="mdi mdi-check-decagram mdi-36px float-right"></i>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserStatsRepository from "../../../../repositories/LockerRoom/Stats/UserStatsRepository";
import AdminUsersRepository from "../../../../repositories/Admin/AdminUsersRepository";

export default {
    name: "StatsInfos",
    data: () => ({
        total: 0,
        current_month: 0,
    }),
    props: {
        user: {
            type: Number,
            required: false,
        },
        dates: {
            type: Object,
            required: false
        }
    },
    computed: {
        dateFrom() {
            return this.dates?.start || null;
        },
        dateTo() {
            return this.dates?.end || null;
        }
    },
    watch: {
        dates: {
            deep: true,
            handler() {
                this.getCounters();
            }
        }
    },
    methods: {
        getCounters() {
            let q;

            if(this.user === null) {
                // User requesting own counters
                q = UserStatsRepository.getCounters(this.dateFrom, this.dateTo);
            } else {
                // Admin requesting counters of other user
                q = AdminUsersRepository.getCounters(this.user, this.dateFrom, this.dateTo);
            }

            q.then((res) => {
                this.total = res.data.total;
                this.current_month = res.data.current_month;
            });
        }
    }
}
</script>

<style scoped>

</style>
